import { Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material'
import { CustomDialogTitle } from '../../../Common/Custom/CustomDialogTitle';
import { AppDatepicker } from '../../../../Component/Common/Components/FormValidationInputs/AppDatepicker';
import { LoadingButton } from '@mui/lab';
import { FieldValues, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { PlatformSalaryTemplateSchema } from './PlatformSalaryTemplateSchema';
import { DynamicCsvRequest } from '../../../../Component/Model/Dto/DynamicCsv';
import { CoreImportService } from '../../../../Component/Api/Import/CoreImportService';

interface IProps {
    closeModal: () => void;
    open: boolean;
}
export const PlatformSalaryImportTemplateModal = (props: IProps) => {

    const { control, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(PlatformSalaryTemplateSchema)
    });

    const handleDownload = async (data: FieldValues) => {
        const request: DynamicCsvRequest = {
            salaryStart: data.salaryStart,
            salaryEnd: data.salaryEnd,
            onlyShowCTC: true
        }

        const result = await CoreImportService.GenerateSalaryExcelImportTemplate(request).catch((err) => { console.log(err) });
   
        if (result) {
            const url = window.URL.createObjectURL(new Blob([result.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'PlatformSalary.xlsx');
            document.body.appendChild(link);
            link.click();
        }
        props.closeModal();
    }

    return (
        <Dialog open={props.open} onClose={props.closeModal} aria-labelledby="form-dialog-title" maxWidth="sm">
            <CustomDialogTitle id="customized-dialog-title" onClose={props.closeModal}>
                Download Salary Template
            </CustomDialogTitle>
            <DialogContent>
                <Grid container component="form" id='PlatformSalaryForm' onSubmit={handleSubmit(handleDownload)} spacing={2} mt={1}>
                    <Grid item xs={5}>
                        <AppDatepicker control={control} name="salaryStart" label="Start Date" inputFormat='yyyy/MM' views={['year', 'month']} showCalendarIcon={true} />
                    </Grid>
                    <Grid item xs={2} container alignItems="center" justifyContent="center">
                        <Typography variant="body2">
                            to
                        </Typography>
                    </Grid>
                    <Grid item xs={5}>
                        <AppDatepicker control={control} name="salaryEnd" label="End Date" inputFormat='yyyy/MM' views={['year', 'month']} showCalendarIcon={true} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <LoadingButton variant="contained" type='submit' form='PlatformSalaryForm' loading={isSubmitting}>
                    Download Excel
                </LoadingButton>
            </DialogActions>
        </Dialog >
    )
}
